import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Container from '../PageBuilder/lib/Container';
import Img from '../PageBuilder/lib/Image';
import List from '../PageBuilder/List';
import ImagePicker from '../PageBuilder/pickers/ImagePicker/ImagePicker';
import TextInput from '../PageBuilder/forms/TextInput';
import RichText from '../PageBuilder/forms/RichText';
import imgSrcHelper from '../PageBuilder/helpers/imgSrcHelper';

class FullWidthGalleryWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
    };
  }

  handleOpenLightBox(e, idx) {
    e.preventDefault();
    this.setState({ lightboxIsOpen: true, currentImage: idx });
  }

  handleCloseLightbox() {
    this.setState({ lightboxIsOpen: false });
  }

  render() {
    const { list, containerSettings } = this.props;
    const slides = list.map(item => ({ src: imgSrcHelper(item.image, 'native_image') }));

    return (
      <Container className="full-width-gallery-wrapper" settings={containerSettings}>
        <div>
          {list.map((item, idx) =>
            <article key={idx} className="full-width-gallery">
              <div className="sidebar">
                <div className="text" dangerouslySetInnerHTML={{__html: item.text}} />

                {item.credits ? <p className="credits">{item.credits}</p> : ''}
              </div>

              <div className="image-wrapper">
                <a href="#" onClick={(e) => this.handleOpenLightBox(e, idx)}>
                  <Img src={item.image} variant="native_image" />

                  <span className="icon-container">
                    <span className="icon-search" />
                  </span>
                </a>
              </div>

            </article>
          )}

          <Lightbox
            open={this.state.lightboxIsOpen}
            close={() => this.handleCloseLightbox()}
            slides={slides}
            index={this.state.currentImage}
          />
        </div>
      </Container>
    );
  }
}

FullWidthGalleryWidget.title = 'Full width gallery';
FullWidthGalleryWidget.preview = '';
FullWidthGalleryWidget.category = 'Lists';
FullWidthGalleryWidget.dialogSize = 'large';

FullWidthGalleryWidget.propTypes = {
  list: PropTypes.array.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

FullWidthGalleryWidget.defaults = {
  list: [
    { id: 1, credits: 'Робърт Джон Торнтън', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus perspiciatis velit, molestias, exercitationem magni cumque nihil earum laborum maxime doloremque. Deleniti harum vero, eos cumque officia aperiam voluptatem veniam tempora.', image: 'http://placehold.it/1920x1000' },
    { id: 2, credits: 'Робърт Джон Торнтън', text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus perspiciatis velit, molestias, exercitationem magni cumque nihil earum laborum maxime doloremque. Deleniti harum vero, eos cumque officia aperiam voluptatem veniam tempora.', image: 'http://placehold.it/800x1200' },
  ],
  containerSettings: {},
};

const FullWidthGalleryField = ({ settings, onChangeItem }) => (
  <div>
    <ImagePicker
      onChange={value => onChangeItem('image', value)}
      value={settings.image}
    />

    <TextInput
      label="Credits"
      onChange={value => onChangeItem('credits', value)}
      value={settings.credits}
    />

    <RichText
      label="Text"
      onChange={value => onChangeItem('text', value)}
      value={settings.text}
    />
  </div>
);

FullWidthGalleryField.propTypes = {
  settings: PropTypes.object.isRequired,
  onChangeItem: PropTypes.func.isRequired,
};

FullWidthGalleryWidget.adminFields = (items, onChange, settings) => (
  <List
    listItem={(settings, onChangeItem) =>
      <FullWidthGalleryField settings={settings} onChangeItem={onChangeItem} />}
    onChangeList={onChange}
    items={items}
  />
);

export default FullWidthGalleryWidget;
